import React from 'react'
import { Link } from 'react-router-dom';

function CalendarInfo({ appointmentToday, appointmentTotal, totalMouthAppointments }) {
  return (
    <>
      <Link to="/home/appointment/get" style={{ textDecoration: 'none' }}>
        <div className='calendarInfo groupBtn-G'>

          <div>Agendamentos de hoje: {appointmentToday}</div>
          <div>Total de Agendamentos este Mês: {totalMouthAppointments}</div>
          <div>Total de Agendamentos: {appointmentTotal}</div>

        </div>
      </Link>
    </>
  )
}

export default CalendarInfo